import { readFile } from "./fsLimit.js";
async function readJSONFile(path) {
  const contents = await readFile(path, "utf8");
  return JSON.parse(contents);
}
export {
  readJSONFile
};
//# sourceMappingURL=readJSONFile.js.map
